import { useIsFocused } from '@react-navigation/native'
import React, { useCallback, useEffect } from 'react'
import { Text } from 'react-native-paper'
import Layout from '../Layout'
import { Input } from '../../../ui/atoms/builder-2.0/Input'
import { observer } from 'mobx-react'
import SubmitButton from '../SubmitButton'
import SignInStore from '../stores/SignInStore'
import RootStore from '../../../store/RootStore'
import useRecaptcha from '../useRecaptcha'
import Title, { SubTitle } from '../Title'
import { Link } from '../../../ui/atoms/Link'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { Spacer } from '../../../ui/atoms'
import { dispatcher, pathFactory, paths } from '../../links'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from '../ErrorMessage'
import useUtm from '../useUtm'
import { routes2 } from '@linqpal/models'

export default observer(({ navigation, dontNavigate, route }) => {
  useUtm(route.params)
  const {
    login,
    isValidEmail,
    canSubmit,
    canAskOtp,
    errors,
    codeVerifier,
    isValidLogin,
    setCanAskPassword,
    setIsNewUser,
  } = SignInStore
  const { isBusy } = RootStore
  const { t } = useTranslation('auth')
  const recaptcha = useRecaptcha('signin')
  useEffect(() => {
    RootStore.initRouteParams(route?.params)
  }, [route?.params])

  const isFocused = useIsFocused()
  const { verifier, createVerifier } = recaptcha
  useEffect(() => {
    if (isFocused && !verifier) createVerifier()
  }, [verifier, createVerifier, isFocused])

  const pressContinue = useCallback(async () => {
    routes2.user
      .check({
        login: login.toLowerCase(),
      })
      .then((res) => {
        setIsNewUser(!res.exists)
      })
    if (isValidEmail) {
      setCanAskPassword(true)
      if (!dontNavigate) {
        const r = dispatcher(pathFactory('Auth.SignInPassword'))
        navigation.navigate(r.name, r.params)
      }
      return
    }
    if (!canSubmit) return
    return SignInStore.signIn(verifier)
      .then(() => {
        if (RootStore.routeParams.loanid) {
          navigation.navigate(paths.Console.Credit.LoanDetails, {
            id: RootStore.routeParams.loanid,
          })
        }
      })
      .catch(() => {})
  }, [
    isValidEmail,
    canSubmit,
    verifier,
    setCanAskPassword,
    dontNavigate,
    navigation,
    login,
    setIsNewUser,
  ])

  useEffect(() => {
    SignInStore.removeError('login')
    if (canAskOtp && !dontNavigate) {
      navigation.navigate(paths.Auth.SignInVerify)
    }
  }, [canAskOtp, dontNavigate, navigation, codeVerifier])
  return (
    <Layout showsBackButton={false}>
      <Title>{t('signIn.title')}</Title>
      <SubTitle style={{ marginTop: 20 }}>{t('subTitle')}</SubTitle>
      <Spacer height={40} />
      <Input
        testID="login"
        value={login}
        onChangeText={SignInStore.setLogin}
        label={t('signIn.loginLabel')}
        autoFocus
        mandatory
      />
      <ErrorMessage error={errors.get('login')?.message} />
      <Spacer height={32} />
      <SubmitButton
        onPress={pressContinue}
        disabled={!isValidLogin || isBusy}
        loading={isBusy}
      >
        {t('signIn.submitLabel')}
      </SubmitButton>
      <Spacer height={40} />
      <Text
        style={{
          fontFamily: 'Inter, sans-serif',
          fontSize: 16,
          fontWeight: '500',
          color: commonColors.textLight,
          alignSelf: 'center',
        }}
        testID="link-to-signup"
      >
        {`${t('signIn.signUpQuestion')} `}
        <Link
          textStyle={{ fontSize: 16, fontWeight: '500' }}
          title={t('SignUp')}
          color={commonColors.accentText}
          testID="signup_link"
          onPress={() =>
            dontNavigate
              ? dontNavigate(false)
              : navigation.replace(paths.Auth.SignUpHome)
          }
        />
      </Text>
    </Layout>
  )
})
